import React from 'react'
import * as S from '../../styles'

const displayNotificationsAndStatus = (
  notificationsAccessState,
  devicesAccessState,
  renderNotificationsWidget,
  renderStatusWidget
) => {
  if (notificationsAccessState && devicesAccessState) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderNotificationsWidget}
        {renderStatusWidget}
      </S.Grid>
    )
  }
}

const displayNotificationsAndPolicy = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  renderNotificationsWidget,
  renderDevicePolicyStatusWidget
) => {
  if (
    notificationsAccessState &&
    !devicesAccessState &&
    devicePolicyAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderNotificationsWidget}
        {renderDevicePolicyStatusWidget}
      </S.Grid>
    )
  }
}

const displayNotificationsAndCustomers = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  renderNotificationsWidget,
  renderCustomersUsersStatusWidget
) => {
  if (
    notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    usersAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderNotificationsWidget}
        {renderCustomersUsersStatusWidget}
      </S.Grid>
    )
  }
}

const displayNotifications = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  endPtSecurityAccessState,
  renderNotificationsWidget
) => {
  if (
    notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderNotificationsWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }
}

const displayNotificationsAndSolutions = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  endPtSecurityAccessState,
  renderNotificationsWidget,
  renderSolutionsWidget
) => {
  if (
    notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderNotificationsWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }
}

const displayStatusAndDeviceStatusAndPolicy = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  renderStatusWidget,
  renderDeviceStatusWidget,
  renderDevicePolicyStatusWidget
) => {
  if (
    !notificationsAccessState &&
    devicesAccessState &&
    devicePolicyAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderStatusWidget}
        {renderDeviceStatusWidget}
        {renderDevicePolicyStatusWidget}
      </S.Grid>
    )
  }
}

const displayStatusAndDeviceStatusAndCustomers = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  renderStatusWidget,
  renderDeviceStatusWidget,
  renderCustomersUsersStatusWidget
) => {
  if (
    !notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    usersAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderStatusWidget}
        {renderDeviceStatusWidget}
        {renderCustomersUsersStatusWidget}
      </S.Grid>
    )
  }
}

const displayStatusAndDeviceStatus = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  endPtSecurityAccessState,
  renderStatusWidget,
  renderDeviceStatusWidget
) => {
  if (
    !notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderStatusWidget}
        {renderDeviceStatusWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }
}

const displayStatusAndDeviceStatusAndSolutions = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  endPtSecurityAccessState,
  renderStatusWidget,
  renderDeviceStatusWidget,
  renderSolutionsWidget
) => {
  if (
    !notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderStatusWidget}
        {renderDeviceStatusWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }
}

const displayPolicyAndCustomers = (
  notificationsAccessState,
  devicesAccessState,
  devicePolicyAccessState,
  usersAccessState,
  endPtSecurityAccessState,
  renderDevicePolicyStatusWidget,
  renderCustomersUsersStatusWidget
) => {
  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    devicePolicyAccessState &&
    usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDevicePolicyStatusWidget}
        {renderCustomersUsersStatusWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }
}

export const FirstRowWidgetsWide = (props) => {
  const notificationsAccessState = props.notificationsAccessState
  const devicesAccessState = props.devicesAccessState
  const devicePolicyAccessState = props.devicePolicyAccessState
  const usersAccessState = props.usersAccessState
  const endPtSecurityAccessState = props.endPtSecurityAccessState

  const renderNotificationsWidget = props.renderNotificationsWidget
  const renderStatusWidget = props.renderStatusWidget
  const renderDeviceStatusWidget = props.renderDeviceStatusWidget
  const renderDevicePolicyStatusWidget = props.renderDevicePolicyStatusWidget
  const renderCustomersUsersStatusWidget =
    props.renderCustomersUsersStatusWidget
  const renderSecureFleetWidget = props.renderSecureFleetWidget
  const renderSolutionsWidget = props.renderSolutionsWidget

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    devicePolicyAccessState &&
    usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDevicePolicyStatusWidget}
        {renderCustomersUsersStatusWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    devicePolicyAccessState &&
    usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDevicePolicyStatusWidget}
        {renderCustomersUsersStatusWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    devicePolicyAccessState &&
    !usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        rightChildFrWidth={8}
      >
        {renderDevicePolicyStatusWidget}
        {renderSecureFleetWidget}
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        rightChildFrWidth={8}
      >
        {renderCustomersUsersStatusWidget}
        {renderSecureFleetWidget}
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    devicePolicyAccessState &&
    !usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDevicePolicyStatusWidget}
        {renderSolutionsWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderCustomersUsersStatusWidget}
        {renderSolutionsWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderSecureFleetWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }

  if (
    !notificationsAccessState &&
    !devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderSolutionsWidget}
        <S.EmptyDiv />
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  return (
    <>
      {displayNotificationsAndStatus(
        notificationsAccessState,
        devicesAccessState,
        renderNotificationsWidget,
        renderStatusWidget
      )}

      {displayNotificationsAndPolicy(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        renderNotificationsWidget,
        renderDevicePolicyStatusWidget
      )}

      {displayNotificationsAndCustomers(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        renderNotificationsWidget,
        renderCustomersUsersStatusWidget
      )}

      {displayNotifications(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        endPtSecurityAccessState,
        renderNotificationsWidget
      )}

      {displayNotificationsAndSolutions(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        endPtSecurityAccessState,
        renderNotificationsWidget,
        renderSolutionsWidget
      )}

      {displayStatusAndDeviceStatusAndPolicy(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        renderStatusWidget,
        renderDeviceStatusWidget,
        renderDevicePolicyStatusWidget
      )}

      {displayStatusAndDeviceStatusAndCustomers(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        renderStatusWidget,
        renderDeviceStatusWidget,
        renderCustomersUsersStatusWidget
      )}

      {displayStatusAndDeviceStatus(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        endPtSecurityAccessState,
        renderStatusWidget,
        renderDeviceStatusWidget
      )}

      {displayStatusAndDeviceStatusAndSolutions(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        endPtSecurityAccessState,
        renderStatusWidget,
        renderDeviceStatusWidget,
        renderSolutionsWidget
      )}

      {displayPolicyAndCustomers(
        notificationsAccessState,
        devicesAccessState,
        devicePolicyAccessState,
        usersAccessState,
        endPtSecurityAccessState,
        renderDevicePolicyStatusWidget,
        renderCustomersUsersStatusWidget
      )}
    </>
  )
}

export default FirstRowWidgetsWide
